import { Actors } from '@/modules/Marketing/types/response'
import dayjs from 'dayjs'
import React from 'react'
import { Typogaphy } from 'vnetwork-ui'
interface MessageProps {
    message: {
        type: string
        text?: string
        [key: string]: any
    }
    className?: string
    assignee?: Actors
}
const Message: React.FC<MessageProps> = ({ message, assignee, className }) => {
    const isIncoming = message?.direction === 'INCOMING'
    const senderName = isIncoming
        ? message?.senders?.[0]?.actorId
        : assignee?.name
    const senderInitials = senderName?.substring(0, 2).toUpperCase() || '??'

    return (
        <div
            className={`flex ${isIncoming ? 'justify-start' : 'justify-end'} ${className}`}
        >
            <div
                className={`flex gap-2 max-w-[75%] ${isIncoming ? 'flex-row' : 'flex-row-reverse'}`}
            >
                {/* Avatar */}
                <div
                    className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-semibold ${isIncoming ? 'bg-gradient-to-br from-gray-500 to-gray-600' : 'bg-gradient-to-br from-blue-500 to-blue-600'}`}
                >
                    {senderInitials}
                </div>

                {/* Message Bubble */}
                <div className="flex flex-col">
                    {/* Sender Name */}
                    <Typogaphy
                        className={`text-xs text-gray-600 mb-1 ${isIncoming ? 'text-left' : 'text-right'}`}
                    >
                        {senderName}
                    </Typogaphy>

                    {/* Message Content */}
                    <div
                        className={`rounded-2xl px-4 py-2 shadow-sm ${
                            isIncoming
                                ? 'bg-white border border-gray-200 rounded-tl-none'
                                : 'bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-tr-none'
                        }`}
                    >
                        <Typogaphy
                            className={`text-sm break-words whitespace-pre-wrap ${isIncoming ? 'text-gray-800' : 'text-white'}`}
                        >
                            {message?.text || ''}
                        </Typogaphy>
                    </div>

                    {/* Timestamp */}
                    <Typogaphy
                        className={`text-xs text-gray-500 mt-1 ${isIncoming ? 'text-left' : 'text-right'}`}
                    >
                        {dayjs(message?.createdAt).format('HH:mm, DD/MM/YYYY')}
                    </Typogaphy>
                </div>
            </div>
        </div>
    )
}

export default Message
